import Vue from 'vue'
import VueRouter from 'vue-router'
import menu from '../data/menu.json'
import store from '../store'

Vue.use(VueRouter)

const DEFAULT_TITLE = 'Management Portal';

let routes = [
  // {
  //   path: '/',
  //   redirect: { name: 'Dashboard' }
  // },
]

function routeBuilder(routes, parentBreadcrumbs, parentRoute, childMenu) {

  for (let menu of childMenu) {
    if (Object.hasOwn(menu, "isDisabled") && menu.isDisabled) {
      continue
    } 
    
    let tempBreadcrumbs = structuredClone(parentBreadcrumbs)
    
    let isBreadcrumbItemDisabled = false
    if ([
      "ProductDetail"
    ].includes(menu.name)) isBreadcrumbItemDisabled = true

    tempBreadcrumbs.push({
      text: menu.title,
      to: menu.name,
      disabled: isBreadcrumbItemDisabled
    })

    let route = {
      path: parentRoute.path + "/" + menu.slug,
      name: menu.name,
      props: (r) => ({
        params: r.params,
        query: r.query,
        meta: r.meta
      }),
      meta: {
        isAuthenticated: true,
        windowTitle: menu.title,
        pageTitle: menu.title,
        menuName: menu.name,
        submenu: menu.submenu,
        isParentMenu: menu.isParentMenu,
        permissions: menu.permissions,
        breadcrumbs: tempBreadcrumbs,
        layout: menu.layout
      },
      component: () => menu.isParentMenu 
        ? import('../views/' + menu.name + 'Page.vue') 
        : import('../views/MenuAppPage.vue')
    }

    routes.push(route)

    if ('submenu' in menu && menu.submenu.length > 0) {
      routeBuilder(routes, tempBreadcrumbs, route, menu.submenu)
    }
  }
}

routeBuilder(routes, [], {path: ''}, menu)

// If route is not found
routes.push({
  path: '/:pathMatch(.*)', 
  component: () => import('../views/PageNotFoundPage.vue')
})

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
      // let title = (store.state.org.portalName) ?  
      //               store.state.org.portalName : DEFAULT_TITLE
      let title = DEFAULT_TITLE
      document.title = to.meta.windowTitle + ' | ' + title
    });
});

router.beforeEach((to, from, next) => {
  if (to.meta.isAuthenticated) {
    // Get the actual url of the app, it's needed for Keycloak
    const basePath = window.location.protocol + '//' + window.location.host
    if (!Vue.$keycloak.authenticated) {
      // The page is protected and the user is not authenticated. Force a login.
      Vue.$keycloak.login({ redirectUri: basePath + to.path })
    } else {
      // If the user was authenticated, check if the token needs to be refreshed.
      Vue.$keycloak.updateToken(5)
        .then((refreshed) => {
          next()
        })
        .catch(err => {
          console.error(err)
          Vue.$keycloak.login({ redirectUri: basePath + to.path })
        })
    }
  } else {
    // This page did not require authentication
    next()
  }
})

export default router